import './style/index.css'
import App from './app'

/* eslint-disable */
if (typeof document !== 'undefined') {
  var _gaq = _gaq || []
  _gaq.push(['_setAccount', 'UA-39222424-1'])
  _gaq.push(['_trackPageview'])
  ;(function() {
    const ga = document.createElement('script')
    ga.type = 'text/javascript'
    ga.async = true
    ga.src = `${document.location.protocol == 'https:'
      ? 'https://ssl'
      : 'http://www'}.google-analytics.com/ga.js`
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(ga, s)
  })()
}
/* eslint-enable */

export default App



// WEBPACK FOOTER //
// ./index.js